var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrellas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.515,
    height: 34.193,
    viewBox: "0 0 33.515 34.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "umbrella-svgrepo-com",
    d: "M21,7A16.159,16.159,0,0,0,5.024,20.248,1.515,1.515,0,0,0,7.29,21.764a3.5,3.5,0,0,1,3.1,0l.692.342a4.1,4.1,0,0,0,3.626,0l.428-.211a4.1,4.1,0,0,1,3.626,0L21,23M21,7c.176,0,.352,0,.825.02A16.066,16.066,0,0,1,36.976,20.248a1.515,1.515,0,0,1-2.267,1.515,3.5,3.5,0,0,0-3.1,0l-.693.342a4.1,4.1,0,0,1-3.626,0l-.428-.211a4.1,4.1,0,0,0-3.626,0L21,23M21,7V5m0,18V35a2.027,2.027,0,0,1-4.054,0V33",
    transform: "translate(-4.242 -3.557)",
    fill: "rgba(255,255,255,0)",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrellas);
export default __webpack_public_path__ + "static/media/umbrellas.02dc3aaa9972ba9b5b93ffa6c01fde3a.svg";
export { ForwardRef as ReactComponent };